import React from "react";
import { isNotUndefined } from "@/shared/FunctionCore";
import { usePageURL } from "@/shared/customHooks";


export interface ParagraphObj {
	"hrefUrl"?: string;
	"label"?: string;
	"text": string;
}

interface Props {
	"paragraph": ParagraphObj[];
	"title": string;
}

const BusinessDirectoryDescriptionContent = (props: Props): JSX.Element => {
	const {
		paragraph,
		title
	} = props;
	const { countryCode } = usePageURL();

	return (
		<div className="directoryDescriptionContainer mt-5">
			<h1 className="headingDescriptionPage">
				{title}
			</h1>
			<hr className="mt-4" />
			<div className="description_content">
				{paragraph.length > 0 ? paragraph.map((content, index) => {
					if (content.text.includes("_link_")) {
						// To add link label and href dynamically from props
						// Note:  the text "_link_" must be in between of other words of para
						// So that after spliting it must have value on 0th and 1st index of the splitted array

						const textBefore = content.text.split("_link_")[0];
						const afterLink = content.text.split("_link_")[1];

						return (
							<p key={`bdd-${index}`}>
								{textBefore}

								{isNotUndefined(content["hrefUrl"]) ?
									<a
										className={`anchor_redirection anchor ${countryCode === 'us' ? "" : "external-icon"}`}
										href={content.hrefUrl}
										rel="noreferrer"
										target={countryCode === 'us' ? "_self": "_blank"}
									>
										{content.label}
									</a> : content.label}

								{afterLink}
							</p>
						);
					}

					return (
						<p key={`bdd-${index}`}>
							{content.text}
						</p>
					);
				}) : <></>}
			</div>
		</div>
	);
};

export default BusinessDirectoryDescriptionContent;
